export const name = 'rnDeviceDetector';

export const UI_STATE = {
  activated: 'activated',
  added: 'added',
  addAvailable: 'addAvailable',
  addUnavailable: 'addUnavailable',
};

export const AAA_DEVICE_PROVISIONED_STATE = {
  unknownState: 5001,
  unmappedModel: 5002,
  duplicateModel: 5003,
  loggedIn: 5004,
  unreleasedModel: 5005,
  existsInOtherOrg: 5006,
  autoProvisionableNONE: 5007,
  autoProvisionableMANUAL: 5008,
  autoProvisionableAUTO: 5009,
};

/**
 * @ngdoc service
 * @name rhino.components.device.service:rnDeviceAutoProvision
 *
 * @description Rhino device auto provision service, providing the state for devices that can be detected by PrintOS.
 */
export default function rnDeviceDetector(rnHttp) {

  'ngInject';
  let thisService = {
    getDevices,
    getDevicesToAdd,
    getDevicesToActivate,
    getCanActivateDevices,
  };
  return thisService;

  /**
   * @ngdoc function
   * @name getDevices
   * @name rhino.components.device.service:rnDeviceAutoProvision
   * @description Returns an array of objects with detected device information
   * @returns {Promise.<Array<Object>>} detected device information
   */
  function getDevices() {
    return rnHttp.get('aaa', 'organizations/devices/provisionedstate').then(resp => {
      return resp.data.map(deviceState => {
        deviceState.uiState = getUiState(deviceState);
        deviceState.canActivate = getCanActivate(deviceState);
        return deviceState;
      });
    });
  }

  function getUiState(deviceState) {
    if (deviceState.state === AAA_DEVICE_PROVISIONED_STATE.loggedIn) {
      return UI_STATE.activated;
    }

    if (deviceState.deviceId) {
      return UI_STATE.added;
    }

    if (deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableNONE ||
      deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableMANUAL ||
      deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableAUTO ||
      deviceState.state === AAA_DEVICE_PROVISIONED_STATE.duplicateModel) {
      return UI_STATE.addAvailable;
    }

    return UI_STATE.addUnavailable;
  }

  function getCanActivate(deviceState) {
    return deviceState.state === AAA_DEVICE_PROVISIONED_STATE.loggedIn ||
      deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableMANUAL ||
      deviceState.state === AAA_DEVICE_PROVISIONED_STATE.autoProvisionableAUTO;
  }

  /**
   * @ngdoc function
   * @name getDevicesToAdd
   * @name rhino.components.device.service:rnDeviceAutoProvision
   * @description Returns an array of objects that can be added manually be the user
   *  and can't be activated, which would cause the device to be automatically added
   * @returns {Promise.<Array<Object>>} array of objects that can be added
   */
  function getDevicesToAdd() {
    return getDevices().then(devices => {
      return devices.filter(device => {
        return (device.uiState === UI_STATE.addAvailable) && !device.canActivate && device.model;
      });
    });
  }

  /**
   * @ngdoc function
   * @name getDevicesToAdd
   * @name rhino.components.device.service:rnDeviceAutoProvision
   * @description Returns an array of objects that can be activated by the user
   *  and are not activated already
   * @returns {Promise.<Array<Object>>} array of objects that can be activated and have not been
   */
  function getDevicesToActivate() {
    return getDevices().then(devices => {
      return devices.filter(device => {
        return (device.uiState !== UI_STATE.activated) && device.canActivate;
      });
    });
  }

  /**
   * @ngdoc function
   * @name getCanActivateDevices
   * @name rhino.components.device.service:rnDeviceAutoProvision
   * @description Returns an array of objects that can be activated or are already activated
   * @returns {Promise.<Array<Object>>} array of devices that can be activated
   */
  function getCanActivateDevices() {
    return getDevices().then(devices => {
      return devices.filter(device => {
        return device.canActivate;
      });
    });
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/device/detector.service.js